// extracted by mini-css-extract-plugin
module.exports = {"quizContainer":"Quiz_quizContainer__SE8Uj"};